import { PaymentMethodTypes } from './PaymentMethodTypes';

export class PaypalSuccessfulPaymentResponseModel {
    public paymentMethodType: PaymentMethodTypes = PaymentMethodTypes.Paypal;
    public id: string;
    public payerId: string;
    public payerEmail: string;
    public state: string;
    public invoiceNumber: string;
}